import { render, staticRenderFns } from "./auth_manage.vue?vue&type=template&id=5be13bab&scoped=true&"
import script from "./auth_manage.vue?vue&type=script&lang=js&"
export * from "./auth_manage.vue?vue&type=script&lang=js&"
import style0 from "./auth_manage.vue?vue&type=style&index=0&id=5be13bab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be13bab",
  null
  
)

export default component.exports